import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-password",
  "use": "icon-password-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-password\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64a224 224 0 0 1 224 224v96h160v576H128V384h160v-96A224 224 0 0 1 512 64z m294.4 409.6H217.6v396.8h588.8V473.6zM512 576a64 64 0 0 1 44.8 109.696v77.696h-89.6v-77.696A64 64 0 0 1 512 576z m0-422.4A134.4 134.4 0 0 0 377.6 288l-0.064 96H646.4v-96A134.4 134.4 0 0 0 512 153.6z\" p-id=\"2670\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol